<template>
<button type="button"
        class="odr-button-clean"
        @click="execFilterCards({
            apply: eApply,
            applyCurrent: eApplyCurrent,
            questionId,
            stateId
        })">
    <slot/>
</button>
</template>
<script>
import '@/scss/blocks/button-clean.scss';

import { execFilterCards } from '@/utils/filter-cards';
import { safeParse } from '@/utils/json';

export default {
    props: {
        apply: {
            default: '{}',
            type: String,
            _descr: 'Filter rules to count',
        },
        applyCurrent: {
            default: 'false',
            type: String,
            _descr: 'Extend currently applied rules',
        },
    },
    computed: {
        eApply () {
            return safeParse(this.apply);
        },
        eApplyCurrent () {
            return safeParse(this.applyCurrent);
        },
        questionId () {
            return this.$el.closest('[data-question-id]').getAttribute('data-question-id');
        },
        stateId () {
            return this.$el.closest('[data-step-id]').getAttribute('data-step-id');
        },
    },
    methods: {
        execFilterCards,
    },
};
</script>
